import { atom } from 'jotai';

import { Maybe } from '@/types';

export type EditMyAccount = {
  showModalInfoChange?: boolean;
  isDirtyForm?: boolean;
  onConfirmNavigation?: () => void;
};

export const defaultShieldTeam: EditMyAccount = {
  showModalInfoChange: false,
  isDirtyForm: false,
  onConfirmNavigation: undefined,
};

export const editMyAccount = atom<Maybe<EditMyAccount>>(defaultShieldTeam);
